import React from 'react';
import { useAppStore } from '../../../GlobalStore/GlobalStore';

interface NoEmbeddingsInstructionsProps {}

const NoEmbeddingsInstructions: React.FC<NoEmbeddingsInstructionsProps> = () => {
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);

    const handleClose = () => {
        setDynamicStateObj({ visiblePopup: null });
    };
    return (
        <div className="fixed inset-0 bg-neutral-100/95 dark:bg-neutral-900/95 flex items-center justify-center p-4 z-50">
            <div className="bg-neutral-300 dark:bg-neutral-800/80 rounded-xl shadow-2xl w-[98%] sm:w-11/12 max-w-md overflow-hidden border border-neutral-700/50">
                <div className="p-6">
                    <h2 className="text-xl font-bold mb-4 dark:text-white text-center">
                        Embeddings Setup
                    </h2>
                    <p className="text-center mb-6 dark:text-neutral-200">
                        At any time you can create embeddings by going to{' '}
                        <span className="font-medium text-neutral-100">
                            Settings → IDE → Create Embeddings
                        </span>
                    </p>
                    <div className="flex justify-center">
                        <button
                            onClick={handleClose}
                            className="bg-cyan-600 px-6 py-2 rounded-full hover:bg-cyan-700 transition-colors duration-200 text-white"
                        >
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoEmbeddingsInstructions;